module.exports = __webpack_public_path__ + "img/media-yinli@2x.c1c8a019.png";